<template>
  <div class="hero">
    <div class="overlay">
      <div class="contents">
        <navigation-links />
        <div class="main-contents"><slot /></div>
        <div class="icon-container"><chevron-down :size="48" /></div>
      </div>
    </div>
  </div>
</template>

<script>
import ChevronDown from "vue-material-design-icons/ChevronDown.vue";
import NavigationLinks from "./NavigationLinks";

export default {
  components: {
    ChevronDown,
    NavigationLinks
  }
};
</script>

<style lang="scss">
@import "../assets/scss/variables";

.hero {
  background-image: url("../assets/cat.jpg");

  height: 100vh;
  background-position: left;
  background-repeat: no-repeat;
  background-size: cover;

  box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.75);

  .overlay {
    height: 100%;
    width: 100%;

    backdrop-filter: blur(3px) grayscale(30%) opacity(0.25) contrast(0.8);
  }

  .contents {
    height: 100%;
    width: 100%;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;

    color: white;

    h1 {
      letter-spacing: 1.5px;
      font-weight: bold;
      text-align: center;

      font-size: 60px;

      @media (max-width: $screen-mobile-min) {
        font-size: 32px;
      }
    }
  }

  .icon-container svg {
    height: 48px;
    width: 48px;
    color: rgba(255, 255, 255, 0.65);
    transition: 0.3s;

    &:hover {
      color: rgba(255, 255, 255);
    }
  }
}
</style>
